__turbopack_context__.v({
  "carousel__container": "learn-content-carousel-module-scss-module__WSrO2W__carousel__container",
  "carousel__filter": "learn-content-carousel-module-scss-module__WSrO2W__carousel__filter",
  "carousel__filters": "learn-content-carousel-module-scss-module__WSrO2W__carousel__filters",
  "carousel__item": "learn-content-carousel-module-scss-module__WSrO2W__carousel__item",
});
